'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _routerHistory = require('../../../../../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

require('../../../../feiseanna/one');

var _common = require('../../../../../common/common.module');

var _common2 = _interopRequireDefault(_common);

var _alert = require('../../../../../alert');

var _alert2 = _interopRequireDefault(_alert);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _mapStateToDialogController = require('./mapStateToDialogController');

var _mapStateToDialogController2 = _interopRequireDefault(_mapStateToDialogController);

var _getStagesSetCurrent = require('ifeis-isomorphic/lib/redux/actions/stages/getStagesSetCurrent');

var _getStagesSetCurrent2 = _interopRequireDefault(_getStagesSetCurrent);

var _openEvent = require('ifeis-isomorphic/lib/redux/actions/events/openEvent');

var _openEvent2 = _interopRequireDefault(_openEvent);

var _closeEvent = require('ifeis-isomorphic/lib/redux/actions/events/closeEvent');

var _closeEvent2 = _interopRequireDefault(_closeEvent);

var _checkinParticipant = require('ifeis-isomorphic/lib/redux/actions/events/checkinParticipant');

var _checkinParticipant2 = _interopRequireDefault(_checkinParticipant);

var _checkoutParticipant = require('ifeis-isomorphic/lib/redux/actions/events/checkoutParticipant');

var _checkoutParticipant2 = _interopRequireDefault(_checkoutParticipant);

var _orderParticipants = require('ifeis-isomorphic/lib/redux/actions/events/orderParticipants');

var _orderParticipants2 = _interopRequireDefault(_orderParticipants);

var _updateRegistration = require('ifeis-isomorphic/lib/redux/actions/events/updateRegistration');

var _updateRegistration2 = _interopRequireDefault(_updateRegistration);

var _index = require('ifeis-isomorphic/lib/redux/actions/setMusic/index');

var _setCurrentStage = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentStage');

var _setCurrentStage2 = _interopRequireDefault(_setCurrentStage);

var _setCurrentEvent = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentEvent');

var _setCurrentEvent2 = _interopRequireDefault(_setCurrentEvent);

var _setCurrentStewardingDay = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentStewardingDay');

var _setCurrentStewardingDay2 = _interopRequireDefault(_setCurrentStewardingDay);

var _setCurrentParticipant = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentParticipant');

var _setCurrentParticipant2 = _interopRequireDefault(_setCurrentParticipant);

var _getFeisDays = require('util/getFeisDays');

var _getFeisDays2 = _interopRequireDefault(_getFeisDays);

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _immutable = require('immutable');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _setCurrentPageSourceForStageStewarding = require('ifeis-isomorphic/lib/redux/actions/stages/setCurrentPageSourceForStageStewarding');

var _setCurrentPageSourceForStageStewarding2 = _interopRequireDefault(_setCurrentPageSourceForStageStewarding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StagesController = function () {
  function StagesController(feis, $ngRedux, fRouterHistoryService, $mdSidenav, msgService, $scope, metadata, $mdDialog, $mdMedia, fAlert, isGod) {
    var _this = this;

    _classCallCheck(this, StagesController);

    this._createOpenDialogInstance = function () {
      return _this._.$mdDialog.confirm().title('Open Event?').textContent('Event is in QA or Results, are you sure you want to Re-Open?').ok('Continue').cancel('Cancel');
    };

    this._ = { $ngRedux: $ngRedux, msgService: msgService, $mdSidenav: $mdSidenav, fRouterHistoryService: fRouterHistoryService, $mdDialog: $mdDialog, $mdMedia: $mdMedia, $scope: $scope, fAlert: fAlert, isGod: isGod, metadata: metadata };
    this.feis = feis;
    this.roles = metadata.grants || [];

    if (!feis.has_competitor_numbers_assigned) {
      this.competitorNumbersNotAssigned = true;
    }

    this.allDaysBetweenFeisStartAndEnd = (0, _immutable.fromJS)((0, _getFeisDays2.default)(feis));

    var feisStartDateStartOfDayMS = (0, _momentTimezone2.default)(feis.dt_start).tz(feis.tz).startOf('day').valueOf();
    var feisEndDateEndOfDayMS = (0, _momentTimezone2.default)(feis.dt_end).tz(feis.tz).endOf('day').valueOf();
    var todayStartOfDayMS = (0, _momentTimezone2.default)().tz(feis.tz).startOf('day').valueOf();

    this._.$ngRedux.dispatch((0, _setCurrentStewardingDay2.default)(feis.id, todayStartOfDayMS > feisEndDateEndOfDayMS || todayStartOfDayMS < feisStartDateStartOfDayMS ? feisStartDateStartOfDayMS : todayStartOfDayMS));

    this._.$ngRedux.dispatch((0, _setCurrentPageSourceForStageStewarding2.default)(this.feis.id, undefined));

    this._.$ngRedux.dispatch((0, _index.getDances)());

    this._.$ngRedux.dispatch((0, _getStagesSetCurrent2.default)(feis.id));

    var mapStage = (0, _mapStateToController2.default)(feis.id);
    this._.$ngRedux.connect(function (state) {
      return mapStage(state);
    })(this);

    this.sortableOptions = {
      orderChanged: function orderChanged() {
        return _this._dragHandler.apply(_this, arguments);
      }
    };
  }

  _createClass(StagesController, [{
    key: 'back',
    value: function back() {
      this._.fRouterHistoryService.back();
    }
  }, {
    key: 'hasFeisStarted',
    value: function hasFeisStarted() {
      return this.currentStewardingDay && new Date(this.feis.dt_start) <= new Date(this.currentStewardingDay);
    }
  }, {
    key: 'musicById',
    value: function musicById(id) {
      if (angular.isUndefined(id)) {
        return;
      }

      var matchedDance = this.dances.find(function (m) {
        return m.id === id;
      });
      return matchedDance && matchedDance.name;
    }
  }, {
    key: 'updateReg',
    value: function updateReg(person) {
      var _this2 = this;

      this._.$ngRedux.dispatch((0, _updateRegistration2.default)(this.feis.id, this.currentEvent.get('id'), person.id, person.reg)).catch(function (e) {
        return _this2.throwError('Could not update competitor registration.');
      });
    }
  }, {
    key: 'showPerson',
    value: function showPerson(person) {
      this._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(this.feis.id, person.get('id')));
    }
  }, {
    key: 'toggleRegValue',
    value: function toggleRegValue(prop) {
      var updatedPerson = _extends({}, this.currentPersonJS);

      if (updatedPerson.reg[prop] !== 1) {
        updatedPerson.reg[prop] = 1;
      } else {
        updatedPerson.reg[prop] = 0;
      }

      this.updateReg(updatedPerson);
    }
  }, {
    key: 'throwError',
    value: function throwError(msg) {
      this._.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'loadEvent',
    value: function loadEvent(event) {
      this._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(this.feis.id, undefined));
      this._.$ngRedux.dispatch((0, _setCurrentEvent2.default)(this.feis.id, event.get('id'), event.get('participants') > 0 ? true : false));
    }
  }, {
    key: 'open',
    value: function open(event) {
      var _this3 = this;

      var $event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (event.get('is_ci_closed')) {
        if ((event.get('is_in_qa') || event.get('is_in_results')) && (this._.isGod || this.roles.includes('chair'))) {
          var dialog = this._createOpenDialogInstance();

          this._.$mdDialog.show(dialog).then(function () {
            return _this3._openEventBasedOnRoles(event, $event);
          });
        } else {
          return this._openEventBasedOnRoles(event, $event);
        }
      } else {
        return this._openEventBasedOnRoles(event, $event);
      }
    }
  }, {
    key: '_openEventBasedOnRoles',
    value: function _openEventBasedOnRoles(event, $event) {
      var _this4 = this;

      return this._.$ngRedux.dispatch((0, _openEvent2.default)(this.feis.id, event.get('id'), event.get('version_id'))).then(function () {
        return _this4._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(_this4.feis.id, undefined));
      }).catch(function (e) {
        if (e && e.errors && e.errors.status === 403) {
          _this4._.fAlert($event, '', 'Contact Chair to reopen competition');
        } else if (e && e.errors && e.errors.status === 417) {
          var _ref = e.errors.data && e.errors.data.errors[0],
              title = _ref.title,
              detail = _ref.detail;

          _this4._.fAlert($event, title, detail);
        } else {
          _this4.throwError('Error opening event. ' + e.getMessage);
        }
      });
    }
  }, {
    key: '_getNextOpenEvent',
    value: function _getNextOpenEvent(event, eventsForCurrentStage) {
      var currentEventList = eventsForCurrentStage.filter(function (e) {
        return e.get('is_ci_closed') === 0 || !e.get('is_ci_closed');
      });

      if (currentEventList.size > 0) {
        return currentEventList.get(0);
      }

      return event;
    }
  }, {
    key: 'close',
    value: function close(event, $event) {
      var _this5 = this;

      this._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(this.feis.id, undefined));
      return this._.$ngRedux.dispatch((0, _closeEvent2.default)(this.feis.id, event.get('id'), event.get('version_id'))).then(function (response) {
        if (response.errors && response.errors.status === 417) {
          var _ref2 = response.errors.data && response.errors.data.errors[0],
              title = _ref2.title,
              detail = _ref2.detail;

          _this5._.fAlert($event, title, detail);
        } else {
          var nextEvent = _this5._getNextOpenEvent(event, _this5.eventsForCurrentStage);
          return _this5._.$ngRedux.dispatch((0, _setCurrentEvent2.default)(_this5.feis.id, nextEvent.get('id'), nextEvent.get('participants') > 0 ? true : false));
        }
      });
    }
  }, {
    key: '_checkin',
    value: function _checkin(event, person) {
      var _this6 = this;

      this._.$ngRedux.dispatch((0, _checkinParticipant2.default)(this.feis.id, event.get('id'), person.get('id'))).catch(function () {
        return _this6.throwError('Error checking in competitor.');
      });
    }
  }, {
    key: '_checkout',
    value: function _checkout(event, person) {
      var _this7 = this;

      this._.$ngRedux.dispatch((0, _checkoutParticipant2.default)(this.feis.id, event.get('id'), person.get('id'))).catch(function () {
        return _this7.throwError('Error checking out competitor.');
      });
    }
  }, {
    key: 'toggleCheckin',
    value: function toggleCheckin(event, person) {
      this._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(this.feis.id, undefined));
      if (event.get('is_ci_opened') !== 1) {
        return;
      }

      if (!person.get('reg').get('is_checked_in')) {
        return this._checkin(event, person);
      } else {
        return this._checkout(event, person);
      }
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate() {
      return _momentTimezone2.default.tz(this.currentStewardingDay, this.feis.tz).format('MMM D');
    }
  }, {
    key: '_dragHandler',
    value: function _dragHandler($event) {
      var _this8 = this;

      this._.$ngRedux.dispatch((0, _setCurrentParticipant2.default)(this.feis.id, undefined));
      var sourceIndex = $event.source.index;

      var targetIndex = $event.dest.index;

      var orderedParticipants = this.participants.toJS();

      var newOrderedParticipants = orderedParticipants.map(function (o, i) {
        if (i === targetIndex) {
          return orderedParticipants[sourceIndex];
          // dancer is being ordered from a lower (say 9) to higher (say 1) rank
        } else if (sourceIndex > targetIndex) {
          if (i > sourceIndex || i < targetIndex) {
            return o;
          } else if (i <= sourceIndex && i !== targetIndex) {
            return orderedParticipants[i - 1];
          }
          // dancer is bring ordered from a higher (say 1) to lower (say 9) rank
        } else {
          if (i < sourceIndex || i > targetIndex) {
            return o;
          } else if (i >= sourceIndex && i !== targetIndex) {
            return orderedParticipants[i + 1];
          }
        }
      });

      this._.$ngRedux.dispatch((0, _orderParticipants2.default)(this.feis.id, this.currentEvent.get('id'), newOrderedParticipants)).catch(function () {
        return _this8.throwError('Error ordering participants.');
      });
    }
  }, {
    key: 'toggleLeftNav',
    value: function toggleLeftNav() {
      this._.$mdSidenav('left').toggle();
    }
  }, {
    key: 'getClassForEventStatus',
    value: function getClassForEventStatus(event) {
      var classes = [];
      if (event.get('commentsReleased') !== 1 && event.get('status') === 'RES') {
        classes.push('is-status-COMMENTS-UNRELEASED');
      } else {
        classes.push('is-status-' + event.get('status'));
      }
      return classes;
    }
  }, {
    key: 'fetchDateAndStage',
    value: function fetchDateAndStage() {
      var _this9 = this;

      this._.$mdDialog.show({
        locals: {
          feis: this.feis,
          allDaysBetweenFeisStartAndEnd: this.allDaysBetweenFeisStartAndEnd
        },
        controller: function controller($ngRedux, $scope, locals) {
          $scope.feis = locals.feis;
          $scope.allDaysBetweenFeisStartAndEnd = locals.allDaysBetweenFeisStartAndEnd;

          $scope.cancel = function () {
            return _this9._.$mdDialog.cancel();
          };

          $scope.setCurrentDate = function (currentDay) {
            return $ngRedux.dispatch((0, _setCurrentStewardingDay2.default)($scope.feis.id, currentDay));
          };

          $scope.fetch = function (stage) {
            $ngRedux.dispatch((0, _setCurrentParticipant2.default)($scope.feis.id, undefined));
            $ngRedux.dispatch((0, _setCurrentStage2.default)($scope.feis.id, stage && stage.get('id')));
          };

          $scope.loadEvent = function (currentEvent, $event) {
            if (currentEvent.get('is_ci_closed')) {
              if ((currentEvent.get('is_in_qa') || currentEvent.get('is_in_results')) && (_this9._.isGod || _this9.roles.includes('chair'))) {
                var dialog = _this9._createOpenDialogInstance();

                _this9._.$mdDialog.show(dialog).then(function () {
                  return openEventBasedOnRoles(currentEvent, $event);
                });
              } else {
                return openEventBasedOnRoles(currentEvent, $event);
              }
            } else {
              $ngRedux.dispatch((0, _setCurrentParticipant2.default)($scope.feis.id, undefined));
              return ($ngRedux.dispatch((0, _setCurrentEvent2.default)($scope.feis.id, currentEvent && currentEvent.get('id'), currentEvent && currentEvent.get('participants') > 0 ? true : false)) || Promise.resolve()).finally(function () {
                return $scope.cancel();
              });
            }
          };
          var mapStageDialog = (0, _mapStateToDialogController2.default)($scope.feis.id);

          var openEventBasedOnRoles = function openEventBasedOnRoles(currentEvent, $event) {
            return $ngRedux.dispatch((0, _openEvent2.default)($scope.feis.id, currentEvent.get('id'), currentEvent.get('version_id'))).then(function () {
              $ngRedux.dispatch((0, _setCurrentParticipant2.default)($scope.feis.id, undefined));
              $ngRedux.dispatch((0, _setCurrentEvent2.default)($scope.feis.id, currentEvent && currentEvent.get('id'), currentEvent && currentEvent.get('participants') > 0 ? true : false)) || Promise.resolve();
            }).catch(function (e) {
              if (e && e.errors && e.errors.status === 403) {
                _this9._.fAlert($event, '', 'Contact Chair to reopen competition');
              } else if (e && e.errors && e.errors.status === 417) {
                var _ref3 = e.errors.data && e.errors.data.errors[0],
                    title = _ref3.title,
                    detail = _ref3.detail;

                _this9._.fAlert($event, title, detail);
              } else {
                _this9.throwError('Error opening event. ' + e.getMessage());
              }
            }).finally(function () {
              return $scope.cancel();
            });
          };

          $ngRedux.connect(function (state) {
            var stageStewardingDialog = mapStageDialog(state);

            if (stageStewardingDialog.loadingStagesDialog) {
              return _extends({}, stageStewardingDialog);
            }

            return _extends({}, stageStewardingDialog);
          })($scope);
        },
        template: require('./selectDateAndStage.tmpl.html'),
        clickOutsideToClose: true,
        fullscreen: this._.$mdMedia('md')
      });
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        return (0, _ifeisIsomorphic.getDescription)(event);
      }
    }
  }]);

  return StagesController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.stages', ['ngMaterial', 'ui.router', 'as.sortable', 'ifeis.router-history', _ngRedux2.default, 'ifeis.common', 'ifeis.routes.feiseanna.one']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.stages', {
    url: '/stages',
    template: require('./tpl.html'),
    controller: StagesController,
    controllerAs: 'stages',
    ncyBreadcrumb: {
      label: 'Stage Stewarding',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/stages/index.js
// module id = 571
// module chunks = 0